"use strict"

import angular from "angular"

angular
  .module("uCountitUiApp")

  .directive("standardExportConfig", () => ({
    restrict: "E",
    templateUrl: "app/admin/company/dataexport/standard-export/standard-config.html",
    controller: "StandardExportConfigCtrl",

    scope: {
      form: "=",
      originalForm: "=",
      selectedItem: "=",
    },
  }))
